// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JyQJMrggng {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.JyQJMrggng h4 {
  line-height: 3em;
}
.JyQJMrggng .D8C0o0oJkZ {
  float: left;
  width: 100%;
}
.JyQJMrggng .srDo_9qr7O {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.JyQJMrggng .srDo_9qr7O:hover {
  cursor: pointer;
}
.JyQJMrggng .srDo_9qr7O:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.tvcyZiaOaF .t3NpMs1I3f:focus {
  outline: none;
}
.tvcyZiaOaF .t3NpMs1I3f.BRXymwKfOb.IaS1ymgxxY {
  background: #375A88;
}
.tvcyZiaOaF .t3NpMs1I3f.BRXymwKfOb.IaS1ymgxxY span {
  color: #fff;
}
.tvcyZiaOaF .IaS1ymgxxY {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.tvcyZiaOaF .IaS1ymgxxY:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.tvcyZiaOaF input {
  height: 38px;
  min-width: 220px;
}
.srDo_9qr7O.xeWj8lZZev {
  background: #410102;
}
.srDo_9qr7O.qqlS4wFs_s {
  background: #911318;
}
.srDo_9qr7O.rGRA9R2mr8 {
  background: #D8293B;
}
.srDo_9qr7O.ZzGyX9onTy {
  background: #F2373C;
}
.srDo_9qr7O.TIACT5J4yE {
  background: #FC4448;
}
.srDo_9qr7O.XSYOY7FTRe {
  background: #ED535E;
}
.srDo_9qr7O.cuNQlMGBg3 {
  background: #E34926;
}
.srDo_9qr7O.Kvo93l0KH_ {
  background: #FC562B;
}
.srDo_9qr7O.msXmnpQrfl {
  background: #FC6722;
}
.srDo_9qr7O.cfRNg3oV1b {
  background: #FD7F24;
}
.srDo_9qr7O.EyMBdhzDl9 {
  background: #FD8D26;
}
.srDo_9qr7O.hT5rFPF9oP {
  background: #EC9C3E;
}
.srDo_9qr7O.QmdMMXVDxO {
  background: #0e673a;
}
.srDo_9qr7O._1_QUXTsyJ {
  background: #208740;
}
.srDo_9qr7O.iyadn3HCcP {
  background: #239718;
}
.srDo_9qr7O._2LDRzxhiH5 {
  background: #55A84D;
}
.srDo_9qr7O.axEfuhus0S {
  background: #4BBE5A;
}
.srDo_9qr7O.YncP7n_xV7 {
  background: #0CCA6A;
}
.srDo_9qr7O._wXs8hOYcG {
  background: #0A3C64;
}
.srDo_9qr7O.uPDLx0Q3MP {
  background: #0d487a;
}
.srDo_9qr7O.EaTtGqEeUU {
  background: #10538d;
}
.srDo_9qr7O.cu4SvMtlm8 {
  background: #115A99;
}
.srDo_9qr7O.PUCD9Y5GjN {
  background: #3387E2;
}
.srDo_9qr7O.GypSeBgSrr {
  background: #1BA9CF;
}
.srDo_9qr7O.hBvpvPqh23 {
  background: #d27c02;
}
.srDo_9qr7O.c4gg4kpo36 {
  background: #fb9402;
}
.srDo_9qr7O.w1LJSCI_Or {
  background: #FD9B30;
}
.srDo_9qr7O.aQ01EEn6kU {
  background: #FDBE2D;
}
.srDo_9qr7O.WA8EafPlrB {
  background: #FED831;
}
.srDo_9qr7O.g7iOWeZsaO {
  background: #FFFD38;
}
.srDo_9qr7O.L1enYir6Um {
  background: #2D215C;
}
.srDo_9qr7O.Axul9dtL3Z {
  background: #483C83;
}
.srDo_9qr7O._I4S1Bqnvq {
  background: #58518d;
}
.srDo_9qr7O.sWEiAD3ltB {
  background: #7068A9;
}
.srDo_9qr7O.KCs6hd5YE7 {
  background: #7f78b2;
}
.srDo_9qr7O.lNeGbl1ge2 {
  background: #8f88bc;
}
.srDo_9qr7O.byWyIPqrkK {
  background: #000;
}
.srDo_9qr7O.rSP8_gU5Wq {
  background: #282626;
}
.srDo_9qr7O.JPlhtRdEIj {
  background: #242222;
}
.srDo_9qr7O.YgjAJ_06e6 {
  background: #353838;
}
.srDo_9qr7O.zX0_TS2zry {
  background: #666;
}
.srDo_9qr7O.eprJ1a6wa4 {
  background: #999;
}
.O1DXp9PCeP {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.O1DXp9PCeP .uQyNUDH8kP {
  display: none;
}
/* Gray (neutral) */
.jMGjmqB28d {
  margin-left: 8px;
}
.jMGjmqB28d .NKxAniGpHf.NKxAniGpHf.NKxAniGpHf {
  background: #FFF;
  border: 1px solid #CAC9CC;
  border-radius: 4px !important;
  width: 32px;
  color: #18181A;
  font-size: 12px;
}
.jMGjmqB28d .NKxAniGpHf.NKxAniGpHf.NKxAniGpHf:hover {
  background: #FFF;
  border: 1px solid #e5e5e5;
}
.jMGjmqB28d .NKxAniGpHf.NKxAniGpHf.NKxAniGpHf .JxcAJ0UZjK {
  margin-top: 1px;
}
.jMGjmqB28d .NKxAniGpHf.NKxAniGpHf.NKxAniGpHf .cPApOAu6Wo {
  margin: 0;
  font-size: 12px;
}
.jMGjmqB28d .Cfp9_GTvCp.Cfp9_GTvCp {
  background: #f5f6fa;
}
.jMGjmqB28d .Cfp9_GTvCp.Cfp9_GTvCp:hover {
  background: #f5f6fa;
}
.Rs8aPqg3VU.Rs8aPqg3VU.Rs8aPqg3VU {
  padding: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `JyQJMrggng`,
	"color-row": `D8C0o0oJkZ`,
	"color-tile": `srDo_9qr7O`,
	"picker-component": `tvcyZiaOaF`,
	"picker-element": `t3NpMs1I3f`,
	"active": `BRXymwKfOb`,
	"btn": `IaS1ymgxxY`,
	"red-1": `xeWj8lZZev`,
	"red-2": `qqlS4wFs_s`,
	"red-3": `rGRA9R2mr8`,
	"red-4": `ZzGyX9onTy`,
	"red-5": `TIACT5J4yE`,
	"red-6": `XSYOY7FTRe`,
	"orange-1": `cuNQlMGBg3`,
	"orange-2": `Kvo93l0KH_`,
	"orange-3": `msXmnpQrfl`,
	"orange-4": `cfRNg3oV1b`,
	"orange-5": `EyMBdhzDl9`,
	"orange-6": `hT5rFPF9oP`,
	"green-1": `QmdMMXVDxO`,
	"green-2": `_1_QUXTsyJ`,
	"green-3": `iyadn3HCcP`,
	"green-4": `_2LDRzxhiH5`,
	"green-5": `axEfuhus0S`,
	"green-6": `YncP7n_xV7`,
	"blue-1": `_wXs8hOYcG`,
	"blue-2": `uPDLx0Q3MP`,
	"blue-3": `EaTtGqEeUU`,
	"blue-4": `cu4SvMtlm8`,
	"blue-5": `PUCD9Y5GjN`,
	"blue-6": `GypSeBgSrr`,
	"yellow-1": `hBvpvPqh23`,
	"yellow-2": `c4gg4kpo36`,
	"yellow-3": `w1LJSCI_Or`,
	"yellow-4": `aQ01EEn6kU`,
	"yellow-5": `WA8EafPlrB`,
	"yellow-6": `g7iOWeZsaO`,
	"purple-1": `L1enYir6Um`,
	"purple-2": `Axul9dtL3Z`,
	"purple-3": `_I4S1Bqnvq`,
	"purple-4": `sWEiAD3ltB`,
	"purple-5": `KCs6hd5YE7`,
	"purple-6": `lNeGbl1ge2`,
	"black-1": `byWyIPqrkK`,
	"black-2": `rSP8_gU5Wq`,
	"black-3": `JPlhtRdEIj`,
	"black-4": `YgjAJ_06e6`,
	"black-5": `zX0_TS2zry`,
	"black-6": `eprJ1a6wa4`,
	"picker-theme": `O1DXp9PCeP`,
	"arrow-regular": `uQyNUDH8kP`,
	"assets-action__menu": `jMGjmqB28d`,
	"action-menu__btn": `NKxAniGpHf`,
	"action-menu__btn--iconRoot": `JxcAJ0UZjK`,
	"action-menu__btn--icon": `cPApOAu6Wo`,
	"action-menu__btn--disable": `Cfp9_GTvCp`,
	"action-menu__ctn": `Rs8aPqg3VU`
};
export default ___CSS_LOADER_EXPORT___;
